export const  ORGANIZATION_PROFILE_RESET_REQUEST='ORGANIZATION_PROFILE_RESET_REQUEST';
export const  ORGANIZATION_PROFILE_RESET_SUCCESS='ORGANIZATION_PROFILE_RESET_SUCCESS';
export const ORGANIZATION_PROFILE_RESET_FAILURE='ORGANIZATION_PROFILE_RESET_FAILURE'